import { PRODUCT_NAMES } from './product-names.js';
import { CCI_MODULE_KEYS } from '../enterprise-entitlements.js';
/** Customer-facing labels for subscription module entitlements. */
export const FEATURE_LABELS = {
    cci_operations: 'CCI Operations',
    cci_vision: 'CCI Vision',
    spatial_connect: 'CCI Spatial Connect',
    spatial_uwb: 'CCI Spatial',
    axon_gateways: 'Axon Gateways',
};
export function getFeatureLabel(featureKey) {
    if (!featureKey) {
        return PRODUCT_NAMES.CCI_FULL;
    }
    return FEATURE_LABELS[featureKey] ?? featureKey.replace(/_/g, ' ');
}
/** Stripe / billing metadata keys that are not module flags. */
export const BILLING_RESOURCE_LABELS = {
    ...FEATURE_LABELS,
    wafers: 'Wafers',
    containers: 'Containers',
    users: 'Users',
    storage: 'Storage',
    encryption: 'Encryption',
    base: 'CCI Operations',
    axon_gateways: 'Axon Gateways',
};
export function getBillingResourceLabel(resourceKey) {
    if (!resourceKey) {
        return 'Resource';
    }
    return BILLING_RESOURCE_LABELS[resourceKey] ?? resourceKey.replace(/_/g, ' ');
}
/** Provider Stripe product creator — module keys to display labels. */
export const PRODUCT_CREATOR_MODULE_LABELS = Object.fromEntries(CCI_MODULE_KEYS.filter((key) => key !== 'cci_operations').map((key) => [key, FEATURE_LABELS[key]]));
export const AXON_GATEWAY_LIMIT_LABEL = 'Max Axon Gateways';
//# sourceMappingURL=feature-labels.js.map